import {combine} from 'effector';

import {fetchOrdersGrid, fetchOrdersGridCount, loadGridCsv} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {OrdersGridRawRow} from 'types';

const domain = rootDomain.createDomain('ordersGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchOrdersGridFx',
    handler: fetchOrdersGrid,
});

export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchOrdersGridCountFx',
    handler: fetchOrdersGridCount,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchOrdersCsv',
    handler: loadGridCsv,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<OrdersGridRawRow[]>([]);
export const totalCount$ = domain.createStore<number>(0);

export const tableState$ = combine({
    data: data$,
    totalCount: totalCount$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    dataLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
    exportPending: fetchCsv.pending,
});
